import ENV from '@/env';
/**
 * 本模块因为当初决策失误导致
 * 若将crumbs存在store中，由store下发面包屑，本模块可以去除
 */
let crumbs = [];

export function setCrumbs(newCrumbs) {
  crumbs = newCrumbs;
}

export function getCrumb({ hasDomain = false } = {}) {
  if (!hasDomain) return crumbs;
  return crumbs.map((item) => {
    return Object.assign({}, item, { path: ENV.ACORE_DOMAIN + item.path });
  });
}

export function resetCrumbs() {}

export default {
  setCrumbs,
  getCrumb,
  resetCrumbs,
};
